export const red = "#ff1616";
export const amber = "#fb8d45";
export const green = "#00FBD9";
export const darkGreen = "#009e88";
export const orange = "#ff8600";
export const purple = "rgba(144, 86, 191, 1)";
export const grey = "#828282";
export const darkGrey = "#585858";
export const darkerGrey = "#2b2a2a";
export const pink = "#FF00FF";
export const redTransparent = "rgba(248, 84, 84, 0.25)";
export const amberTransparent = "rgba(252, 187, 21, 0.25)";
export const greenTransparent = "rgba(51, 189, 146, 0.25)";
export const cyan = "#06dcbf";
export const lightBlue = "#00d0df";
export const darkBlue = "#00a4da";
export const blueGradientBackground = "linear-gradient(90deg, rgba(19,209,156,1) 0%, rgba(37,144,214,1) 100%)";
export const redFilter = "invert(21%) sepia(66%) saturate(7447%) hue-rotate(354deg) brightness(107%) contrast(102%)";
export const greenFilter = "invert(72%) sepia(46%) saturate(2266%) hue-rotate(119deg) brightness(105%) contrast(103%)";
export const greyFilter = "invert(7%) sepia(0%) saturate(1%) hue-rotate(186deg) brightness(94%) contrast(76%)";
export const pinkFilter = "invert(20%) sepia(98%) saturate(2492%) hue-rotate(288deg) brightness(117%) contrast(144%)";